module.exports = __webpack_public_path__ + "static/media/Banner01.1eced063.jpg";